import React from 'react';
import './home.css';

const ImageContent = () => {
    return (
        <div className='bg_image bg-[#072320] rounded-lg shadow'>
            <div className=' py-8 flex flex-col justify-center items-start' data-aos="fade-right" data-aos-delay="200">
                <h1 className="text-white pl-[130px] cashback_box
                  font-dm text-2xl mb-2 capitalize font-medium pb-2" >
                    get $2 cashback! min order of $22</h1>
            </div>
        </div>

    );
};

export default ImageContent;